import { Divider, Flex, Form, Typography } from "antd";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton, DefaultDateInput } from "ui";
import { _isRequiredDate, _dateIsNotFuture, dateFormat, requestWithNotify } from "utils";
import dayjs from "dayjs";
import { extendQuote } from "services";
import { useNotificationContext } from "providers";

type QuoteExtendModalProps = {
  quoteExpTime: string;
  id: string;
};

const QUOTE_LIST_DELAY = 1000;

export const QuoteExtendModal = observer(({ quoteExpTime, id }: QuoteExtendModalProps) => {
  const { actionModals, quotes } = useStores();
  const [form] = Form.useForm();
  const dateSelected = Form.useWatch("quoteExpTime", form);
  const { openNotification } = useNotificationContext();

  const disabled = dayjs(dateSelected).isSame(dayjs(quoteExpTime), "minute");

  async function handleSubmit() {
    const res = await requestWithNotify({
      fetchFn: () => extendQuote({ id, newQuoteExpTime: dateSelected }),
      openNotification,
      successMsg: "Котировка успешно продлена",
    });

    if (res.result) {
      handleCloseModal();
      requestWithNotify({
        fetchFn: () => quotes.fetch(),
        openNotification,
        successMsg: "Котировки успешно обновлены",
        delay: QUOTE_LIST_DELAY,
      });
    }
  }

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  return (
    <Flex vertical>
      <Form
        form={form}
        name="quoteExtendForm"
        initialValues={{ quoteExpTime: dayjs(quoteExpTime) }}
        onFinish={handleSubmit}
      >
        <Form.Item
          name="quoteExpTime"
          rules={[_isRequiredDate("Укажите дату продления котировки")]}
          validateDebounce={FORM_VALIDATION_DEBOUNCE}
        >
          <DefaultDateInput
            placeholder="Котировка действительна до"
            showTime
            format="DD.MM.YYYY HH:mm"
            maxDate={undefined}
            minDate={dayjs(quoteExpTime)}
          />
        </Form.Item>

        <Form.Item>
          <Flex gap="large">
            <CustomButton style={{ width: "240px" }} variant="outlined" htmlType="button" onClick={handleCloseModal}>
              Отмена
            </CustomButton>
            <CustomButton
              style={{ width: "240px" }}
              htmlType="submit"
              disabled={disabled}
              tooltip={disabled ? "Выберите другую дату" : undefined}
            >
              Подтвердить
            </CustomButton>
          </Flex>
        </Form.Item>
      </Form>
    </Flex>
  );
});
